import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("authorizations", [], router);

export const authorizationsService = {
  ...baseService,
  listPaginated: (params) => api.getCall("/api/authorizations/paginated", params),
  getByClientId: (clientId) => api.getCall(`/api/authorizations/by-client/${clientId}`),
  getFutureAuthorizations: (clientId, serviceCodeId) => {
    const url = serviceCodeId
      ? `/api/authorizations/future/${clientId}/${serviceCodeId}`
      : `/api/authorizations/future/${clientId}`;
    return api.getCall(url);
  },
  attachFutureAuthorizations: (authorizationId, futureAuthIds) => {
    return api.postCall("/api/authorizations/attach-future", {
      authorizationId,
      futureAuthIds
    });
  },
  deactivate: (id) => api.putCall(`/api/authorizations/${id}/deactivate`, {}),
  activate: (id) => api.putCall(`/api/authorizations/${id}/activate`, {}),
  hardDelete: (id) => api.deleteCall(`/api/authorizations/${id}/hard-delete`),
  generateUsor95Pdf: (authorizationId, month, year) =>
    api.getBlobCall(`/api/usor95/${authorizationId}/${month}/${year}`),
  generateUsor96Pdf: (authorizationId, month, year) =>
    api.getBlobCall(`/api/usor96/${authorizationId}/${month}/${year}`),
  bulkImport: (file, authBeginDate, authEndDate) => {
    const formData = new FormData();
    formData.append("file", file);
    if (authBeginDate) formData.append("auth_begin_date", authBeginDate);
    if (authEndDate) formData.append("auth_end_date", authEndDate);
    return api.postFormDataCall("/api/authorizations/bulk-import", formData);
  },
};
